import {
  BobcatTravellerWithBearersDTO,
  TravellerBearerDTO,
} from '@/api/trafikportalen';
import { formatCardNumber } from '@/helpers/formatting';
import { useCallback } from 'react';

export type BearerSource = 'alltix' | 'private';

export interface BearerListItem extends TravellerBearerDTO {
  source: BearerSource;
}

export const useBearerMapping = () => {
  const mapTravellerBearers = useCallback(
    (travellerBearers: BobcatTravellerWithBearersDTO): BearerListItem[] => {
      if (!travellerBearers) {
        return [];
      }

      const mapBearer = (
        bearer: TravellerBearerDTO,
        source: BearerSource,
      ): BearerListItem => ({
        ...bearer,
        serial: formatCardNumber(bearer.serial ?? ''),
        source,
      });

      return [
        ...travellerBearers.alltix_bearers.map((bearer) =>
          mapBearer(bearer, 'alltix'),
        ),
        ...travellerBearers.private_bearers.map((bearer) =>
          mapBearer(bearer, 'private'),
        ),
      ];
    },
    [],
  );

  return {
    mapTravellerBearers,
  };
};
